import type { ConversationsParams, ConversationStatus } from '../services/conversations';
import { ASSIGNEE_FILTER_ME, ASSIGNEE_FILTER_UNASSIGNED } from './assigneeFilter';

// Params pages/Conversations.tsx reads. A row is the pair (patientId, status),
// so a link to one panel carries both; `assignee`/`filter` seed the list's
// filters once from the incoming link.
export const CONVERSATION_PATIENT_PARAM = 'patientId';
export const CONVERSATION_STATUS_PARAM = 'status';
export const CONVERSATION_ASSIGNEE_PARAM = 'assignee';
export const CONVERSATION_TEAM_PARAM = 'team';
export const CONVERSATION_FILTER_PARAM = 'filter';

// The only assignee labels a link may carry: anything else would become a
// filter chip the dropdown can't clear and an empty list.
export const ASSIGNEE_ASSIGNABLE_LABELS: readonly string[] = [
    ASSIGNEE_FILTER_ME,
    ASSIGNEE_FILTER_UNASSIGNED
];

export interface ConversationsLinkOptions {
    patientId?: string;
    /** Which of the patient's two threads the link opens. */
    status?: ConversationStatus;
    /** One or more assignee labels; repeated on the wire, like the list filter. */
    assignee?: string | string[];
    team?: string | string[];
    filter?: ConversationsParams['filter'];
}

function appendAll(params: URLSearchParams, key: string, value?: string | string[]): void {
    if (!value) return;
    for (const item of Array.isArray(value) ? value : [value]) {
        if (item) params.append(key, item);
    }
}

/** Builds a link into the Conversations page, optionally pinned to one patient. */
export function buildConversationsUrl(options: ConversationsLinkOptions = {}): string {
    const params = new URLSearchParams();
    appendAll(params, CONVERSATION_ASSIGNEE_PARAM, options.assignee);
    appendAll(params, CONVERSATION_TEAM_PARAM, options.team);
    if (options.filter) params.set(CONVERSATION_FILTER_PARAM, options.filter);
    if (options.patientId) params.set(CONVERSATION_PATIENT_PARAM, options.patientId);
    if (options.status) params.set(CONVERSATION_STATUS_PARAM, options.status);
    const query = params.toString();
    return query ? `/conversations?${query}` : '/conversations';
}
